import React from "react";
import { Container, ContainerRight, ContainerLeft, Form, Logo, WelcomeText, SmallText, InputIconContainer, Input, OTPContainer, Button, Label } from "./styles/login";

export default function Login({children,...props}){
    return <Container {...props}>{children}</Container>
}

Login.ContainerRight = function LoginContainerRight({children, ...props}){
    return <ContainerRight {...props}>{children}</ContainerRight>
}

Login.ContainerLeft = function LoginContainerLeft({children, ...props}){
    return <ContainerLeft {...props}>{children}</ContainerLeft>
}

Login.Form =  function LoginForm({children, ...props}){
    return <Form {...props}>{children}</Form>
}

Login.Logo = function LoginLogo({...props}){
    return <Logo {...props} />
}

Login.WelcomeText = function LoginWelcomeText({children, ...props}){
    return <WelcomeText {...props} >{children}</WelcomeText>
}

Login.SmallText = function LoginSmallText({children, ...props}){
    return <SmallText {...props} >{children}</SmallText>
}

Login.InputIconContainer = function LoginInputIconContainer({children, ...props}){
    return <InputIconContainer {...props} >{children}</InputIconContainer>
}

Login.Input = function LoginInput({...props}){
    return <Input {...props} />
}

Login.OTPContainer = function LoginOTPContainer({children, ...props}){
    return <OTPContainer {...props}>{children}</OTPContainer>
}

Login.Label = function LoginLabel({children, ...props}){
    return <Label {...props}>{children}</Label>
}

Login.Button = function LoginButton({children, ...props}){
    return <Button {...props}>{children}</Button>
}


